import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, take } from 'rxjs/operators';
import { GridCompatibilityOrderProcessService } from 'src/app/+grid-compatibility/services/grid-compatibility-order-process.service';
import { RegepProcessStatus } from 'src/app/+regep/entities/enums/regepProcessStatus';
import { RegepApplicationService } from 'src/app/+regep/services/regep-application.service';
import { RegepOrderProcessService } from 'src/app/+regep/services/regep-order-process.service';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { InstallationFlowType } from 'src/app/constants/app.constants';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-application-steps',
  templateUrl: './application-steps.component.html',
  styleUrls: ['./application-steps.component.scss'],
})
export class ApplicationStepsComponent extends DestroyableComponent implements OnInit {
  @Input() currentStep: number;
  @Input() isDetailsView: boolean;
  @Input() showTechnicalFormFirst: boolean;

  private customerAddedData: boolean;
  private regepProcessStatus: RegepProcessStatus;
  applicationType: string;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private regepOrderProcessService: RegepOrderProcessService,
    private gridCompatibilityOrderProcessService: GridCompatibilityOrderProcessService,
    private userService: UserService,
    private regepAppliacationService: RegepApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setOrderProcessStatus();
  }

  get showRegulatoryData(): boolean {
    const showForModerator = this.userService.isUserModeratorRole() && this.customerAddedData;
    const showForCustomer = this.regepAppliacationService.isApplicationCustomer;
    const matchApplicationType = this.applicationType === InstallationFlowType.RegEP;
    const matchOrderStatus = this.regepProcessStatus >= RegepProcessStatus.EngineeringOk;

    return matchApplicationType && (showForModerator || (showForCustomer && matchOrderStatus));
  }

  get showResultsPage(): boolean {
    return this.userService.isUserModeratorRole();
  }

  navigate(target: string) {
    const module = this.route.snapshot.data.module;
    const applicationId = Number(this.route.snapshot.paramMap.get('id'));

    this.router.navigate([module, target, applicationId]);
  }

  private setOrderProcessStatus() {
    this.preventLeak(this.regepOrderProcessService.orderProcess$)
      .pipe(debounceTime(0))
      .subscribe(orderProcess => {
        this.customerAddedData = orderProcess.customerAddedData;
        this.applicationType = InstallationFlowType.RegEP;
        this.regepProcessStatus = orderProcess.status;
      });

    this.preventLeak(this.gridCompatibilityOrderProcessService.orderProcess$)
      .pipe(take(1))
      .subscribe(orderProcess => {
        this.applicationType = InstallationFlowType.GridCompatibility;
      });
  }
}
